
import {throwError as observableThrowError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders } from '@angular/common/http';
import {UserService} from './user.service';
import {CookieService} from 'ngx-cookie-service';
import {environment} from '../../client/environments/environment';

@Injectable()
export class AuthService {
  private _baseURL = "/auth/local";
  private _isRequesting = false;

  constructor(private _http:HttpClient, private _user:UserService, private cookieService: CookieService) {
  }

  isLoggedIn() {
    if (this._user.isLoggedIn() === false && this._isRequesting === false) {
      this._isRequesting = true;
      this._user.whoAmI().catch(
        err => {
          this._isRequesting = false;
        }
      ).subscribe(
        res => {
          this._isRequesting = false;
        },
        err => {
          this._isRequesting = false;
        }
      )
    }
    return this._user.isLoggedIn();
  }

  logIn(user) {
    let url = this._baseURL;
    let headers = new HttpHeaders({'Content-Type': 'application/json'});

    //noinspection TypeScriptValidateTypes
    return this._http.post(url, JSON.stringify(user), {headers: headers}).pipe(
      map((res: any) => {
        console.log("set cookie token on", environment.domain);
        this.cookieService.set('token', res.token, null, '/', environment.domain == "localhost" ? "" : environment.domain, false, 'Lax');
        return res.token;
      }),
      catchError(this._handleError),);
  }

  logOut() {
    this.cookieService.delete('token');
    this._user.logOut();
  }

  private _handleError(error:Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return observableThrowError(error['message'] || error['_body'] || 'Server error');
  }
}
